import scrambler from 'vg-poid-scrambler';
import CookieService from './CookieService';
import DataRetrievalService from './DataRetrievalService';
import LoggedOnStatusService from './LoggedOnStatusService';

export default class UserDetailsService {
  public allRetrievalService: DataRetrievalService = new DataRetrievalService();
  public readonly loggedOnStatusService: LoggedOnStatusService = new LoggedOnStatusService();

  public clearCache(): void {
    this.allRetrievalService.clearCache();
  }

  public getUserInfo(dataResponse, loginResponse = LoggedOnStatusService.LOGGED_OUT) {
    const userData: any = {};
    const {
      clientOfferType,
      vbsSegment,
      id,
      institutionalAdviceService,
      employeeAccount,
      retailAccount,
      segmentTypeCode,
      firstAccountDate,
      birthDate,
      crewMember,
    } = dataResponse || {};

    userData.crewsPOID = CookieService.getCookie('CREW_POID');
    userData.loginStatus = loginResponse || LoggedOnStatusService.LOGGED_OUT;

    if (dataResponse) {
      userData.clientOfferType = clientOfferType;
      userData.vbsSegment = vbsSegment;
      userData.sPOID = scrambler(id);
      userData.participantExperienceRelationship = this.determineParticipantExperienceRelationship(
        institutionalAdviceService,
        employeeAccount,
        retailAccount,
      );
      userData.clientSegment = segmentTypeCode;
      userData.clientTenure = this.getMonthDifference(firstAccountDate).toString();
      userData.age = this.getYearDifference(birthDate).toString();
      userData.crewFlag = Boolean(crewMember).toString();
    }

    return userData;
  }

  private determineParticipantExperienceRelationship(
    institutionalAdviceService: boolean,
    employeeAccount: boolean,
    retailAccount: boolean,
  ): string | undefined {
    let result: string | undefined;

    if (retailAccount) {
      // Has retail + at least one of institutional/employee = 'Crossover' else 'Retail Only'
      result = institutionalAdviceService || employeeAccount ? 'Crossover' : 'Retail Only';
    } else if (institutionalAdviceService && employeeAccount) {
      // No retail account but has both institutional and employee = PE Only
      result = 'PE Only';
    }

    return result;
  }

  private getYearDifference(inputDate): number {
    const today = new Date();
    const date = new Date(inputDate);
    return today.getFullYear() - date.getFullYear();
  }

  private getMonthDifference(inputDate): number {
    const MONTHS_IN_YEAR = 12;
    const b = new Date();
    const a = new Date(inputDate);

    let months = (b.getFullYear() - a.getFullYear()) * MONTHS_IN_YEAR;
    months += b.getMonth() - a.getMonth();
    if (b.getDate() < a.getDate()) {
      months--;
    }
    return months;
  }
}
